<script setup lang="ts">
import PatientOrderAlignersAddEditForm from "@/components/models/patient/forms/PatientOrderAlignersAddEditForm.vue";
import { usePatient } from "@/composables/models/patient/usePatient";
import { useAbility } from "@casl/vue";
import { definePage } from "unplugin-vue-router/runtime";
import { computed } from "vue";
import { useRoute } from "vue-router";

definePage({
  meta: {
    title: "generic.action.addEntity",
    titleParams: { entity: "generic.entity.orderAligners" },
    checkPrivileges: () => {
      const { can } = useAbility();
      return can($permActions.CREATE, $permSubjects.PATIENT__ORDERALIGNERS);
    },
  },
});

const route = useRoute();
const patientId = computed(() => (route.params as { id: string }).id);

const { data: patient, isLoading: isPatientLoading } = usePatient({ id: patientId });
</script>

<template>
  <loading v-if="isPatientLoading" />
  <template v-else>
    <patient-order-aligners-add-edit-form
      v-if="patient"
      :patient="patient"
    />
    <span
      v-else
      class="tw:text-center tw:mt-5"
    >
      {{ $t("models.patient.shared.noPatient") }}
    </span>
  </template>
</template>

<style scoped></style>
